import * as yup from 'yup';

export const schema = yup.object({
  dta_inicio: yup.string().required(),
  dta_final: yup.string().required(),
});
